export default {
	data: function(){
        return {
            remember: false
        };
    }
};
